import { buildContract } from '../helpers.js';
export async function buildRefundTx(signer, params) {
    if (!params.contractAddress)
        throw new Error('No contract address');
    const contract = buildContract(params.contractAddress, signer.account);
    return contract.functions.refund_user(params.id).fundWithRequiredCoins();
}
